import "./SocialLinks.css";
import { ARTIST_LINKS } from "../../data/artist";
import { track } from "../../utils/analytics";
import facebookIcon from "../../assets/facebook_icon.png";
import instagramIcon from "../../assets/instagram_icon.png";
import youtubeIcon from "../../assets/youtube_icon.png";
import spotifyIcon from "../../assets/spotify_icon.png";
import tiktokIcon from "../../assets/tiktok_icon.svg";
import threadsIcon from "../../assets/threads_icon.svg";
import soundcloudIcon from "../../assets/soundcloud_icon.png";

const RESUME_LINK = "/thangcao-resume.pdf";
const LINKEDIN_LINK = "https://www.linkedin.com/in/minhthangcao/";
const GITHUB_LINK = "https://github.com/ThangMinhCao";

const SOFTWARE_LINKS = [
  { name: "LinkedIn", href: LINKEDIN_LINK, className: "linkedin-button" },
  { name: "GitHub", href: GITHUB_LINK, className: "github-button" },
  { name: "Resume", href: RESUME_LINK, className: "resume-button" },
];

// Artist links live in data/artist.js. Each icon image is used as a shape
// (CSS mask) filled with a color: white normally, the brand color on hover.
const MUSIC_ICONS = {
  facebook: facebookIcon,
  instagram: instagramIcon,
  youtube: youtubeIcon,
  spotify: spotifyIcon,
  tiktok: tiktokIcon,
  threads: threadsIcon,
  soundcloud: soundcloudIcon,
};
const MUSIC_LINKS = ARTIST_LINKS.map(({ key, name, href, color, glow }) => ({
  key,
  glow,
  name,
  href,
  icon: MUSIC_ICONS[key],
  color,
}));

const SocialLinks = ({
  white = false,
  music = false,
  background = undefined,
  position = "centered",
  fixed = false,
  inverted = false,
  label = undefined, // optional caption shown above the icons, e.g. "follow thangcao"
  className = "", // extra classes, e.g. for page-specific styling
  exclude = [], // artist links to leave out here, by key, e.g. ["spotify"]
}) => {
  const links = music ? MUSIC_LINKS.filter(({ key }) => !exclude.includes(key)) : SOFTWARE_LINKS;

  return (
    <div
      className={`links ${white ? "white-icons" : ""} ${music ? "music-links" : ""} ${
        position
      }-links ${label ? "has-label" : ""} ${className}`}
      style={{
        background: background ? background : "",
        position: fixed ? "fixed" : "absolute",
      }}
    >
      {label ? <span className="links-label">{label}</span> : null}
      {links.map(({ name, href, className, icon, color, glow }) => (
        // The link carries the name (hover tooltip + screen readers);
        // the button inside only draws the icon.
        <a
          key={name}
          className={glow ? "is-glow" : undefined}
          target="_blank"
          rel="noopener noreferrer"
          href={href}
          title={name}
          aria-label={name}
          style={color ? { "--brand": color } : undefined}
          onClick={() => track("social_click", { platform: name, place: window.location.pathname })}
        >
          <button
            className={music ? "icon-button music-icon-button" : `icon-button ${className}`}
            style={
              icon
                ? { WebkitMaskImage: `url(${icon})`, maskImage: `url(${icon})` }
                : undefined
            }
            tabIndex={-1}
            aria-hidden="true"
          />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
